import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Observable, debounceTime, distinctUntilChanged, map, startWith } from 'rxjs';
import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { IDocentesID, IListaReportes, IOrigenObj, IResOrigen, ISecciones, ISedes } from 'src/app/interfaces/auditoria';
import { IListaAnhos, IListaAsignaturas, IListaPeriodos } from 'src/app/interfaces/ponderaciones';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { AuditoriaService } from 'src/app/services/reporte-auditoria/auditoria.service';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-view-reporte-auditoria',
  templateUrl: './view-reporte-auditoria.component.html',
  styleUrls: ['./view-reporte-auditoria.component.scss']
})
export class ViewReporteAuditoriaComponent implements OnInit {
  dtOptions: DataTables.Settings | any = { ...DatatableConfig.dtOptionsWithPopOver }


  tieneErrores: any= {};
  filtroAnyoSeleccionado: number = 0;
  filtroPeriodoSeleccionado: number = 0;
  filtroSedeSeleccionado: number = 0;
  filtroAsignaturaSeleccionado: number = 0;
  filtroCodigoAsignaturaSeleccionado: string = "";
  filtroTipoCambioSeleccionado: string = 'SECCIONES';
  filtroDocenteSeleccionado: number = 0;
  filtroSeccionSeleccionado: number = 0;

  filtroTipoCalificacionSeleccionado: string = '';
  inputFecha: string = ''
  filtroOrigenSeleccionado: number = 0;
  inputRutAlumno: string = ''

  filtroAnyos: Array<number> = [];
  filtroPeriodos: Array<any> = [];
  filtroSedes: Array<any> = [];
  filtroAsignaturas: Array<any> = [];
  filtroDocentes: Array<any> = [];
  filtroSecciones: Array<any> = [];
  filtroOrigenes: Array<IOrigenObj> = []

  filteredAsignatura: Observable<Array<any>>
  filteredSeccion: Observable<Array<any>>
  filteredDocente: Observable<Array<any>>
  searchAsignaturaForm = new FormControl('')
  searchSeccionForm = new FormControl('')
  searchDocenteForm = new FormControl('')

  listaReportes: Array<any> = [];
  funcionIntervalo: any;
  reporteEnProceso: boolean = false;

  submitted: boolean = false;
  rolUsuario: number | null = null;
  habilitarBtnGenerarReporte: boolean = false;

  renderTabla: boolean = true;
  error: string = "";

  parametrosForm = this.formBuilder.group({
    asignatura: [''],
    docente: [''],
    seccion: ['']
  })


  constructor(private _auditoria: AuditoriaService,
              private _perfilamiento: PerfilamientoService,
              private formBuilder: FormBuilder,
              private datePipe: DatePipe
              ){
    let user = this._perfilamiento.getUsuario();
    this.rolUsuario = user.rolId;
    this.filteredAsignatura = this.searchAsignaturaForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', "asignatura")),
    );
    this.filteredSeccion = this.searchSeccionForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', "seccion")),
    );
    this.filteredDocente = this.searchDocenteForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', "docente")),
    );

    this.searchAsignaturaForm.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged()
    )
      .subscribe(res => {
        this.filtroSeccionSeleccionado = 0;
        this.filtroDocenteSeleccionado = 0;
        this.filtroDocentes = [];
        this.searchDocenteForm.setValue("")
        this.tieneErrores["asignatura"] = false;
        this.tieneErrores["seccion"] = false;
        this.tieneErrores["docente"] = false;
        if (typeof res === 'object') {
          let id = this.obtenerId(res)
          let codigo = this.obtenerCodigo(res);
          this.filtroAsignaturaSeleccionado = id
          this.filtroCodigoAsignaturaSeleccionado = codigo;
          // this.getListaSecciones()
          this.getListaDocentes();
        } else {
          this.filtroCodigoAsignaturaSeleccionado = "";
          this.filtroAsignaturaSeleccionado = 0;
          if (res == ""){
            this.getListaDocentes()
          }
        }
      })

      this.searchSeccionForm.valueChanges.pipe(
        debounceTime(400),
        distinctUntilChanged()
      )
        .subscribe(res => {

          this.filtroDocenteSeleccionado = 0;
          this.filtroDocentes = [];
          this.searchDocenteForm.setValue("")
          this.tieneErrores["seccion"] = false;
          this.tieneErrores["docente"] = false;
          if (typeof res === 'object') {
            this.filtroDocentes = []
            let id = this.obtenerId(res)
            this.filtroSeccionSeleccionado = id
            this.getListaDocentes()
          } else {
            this.filtroSeccionSeleccionado = 0;
            if (res == ""){
              this.getListaDocentes()
            }
          }
        })

        this.searchDocenteForm.valueChanges.pipe(
          debounceTime(400),
          distinctUntilChanged()
        )
          .subscribe(res => {
            this.tieneErrores["docente"] = false;
            if (typeof res === 'object') {
              let id = this.obtenerId(res)
              this.filtroDocenteSeleccionado = id
            } else {
              this.filtroDocenteSeleccionado = 0;
            }
          })

  }


  ngOnInit(): void {

    this.dtOptions = { ...DatatableConfig.dtOptionsWithPopOver };
    this.dtOptions.order = [[0,"desc"]];


    this.getAnyos();
    this.getSedes();
    this.getOrigenes();

    this.actualizarTabla();
  }
  activarBtnGenerar(): boolean {
    if (this.rolUsuario === 2) {
      if (this.filtroAnyoSeleccionado == 0 || this.filtroPeriodoSeleccionado == 0 || this.filtroSedeSeleccionado == 0) {
        return false;
      }
    }
    if (this.filtroAnyoSeleccionado == 0 || this.filtroPeriodoSeleccionado == 0){
      return false;
    }
    return true;
  }
  seleccionFiltro(filtro: string): void {
    switch (filtro) {
      case "anyo":
        this.limpiarFiltros("anyo");
        this.tieneErrores["anyo"] = false;
        this.getPeriodos();
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar()
        break;
      case "periodo":
        this.limpiarFiltros("periodo");
        this.tieneErrores["periodo"] = false;
        if(this.rolUsuario != 2) {
          this.tieneErrores["docente"] = false;
          this.getAsignaturas();
          this.getListaDocentes();
        }
        this.getListaSecciones()
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar()
        break;
      case "sede":
        this.limpiarFiltros("sede");
        this.tieneErrores["sede"] = false;
        this.tieneErrores["asignatura"] = false;
        this.tieneErrores["seccion"] = false;
        this.tieneErrores["docente"] = false;
        this.getAsignaturas();
        this.getListaDocentes();
        if ( this.filtroAnyoSeleccionado !== 0 && this.filtroPeriodoSeleccionado !== 0 ) {
          this.getListaSecciones()
        }
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar()
        break;
      case "tipoCambio":
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar()
        break;
      default:
        break;
    }
  }

  casePeriodoSede() {
    this.filtroAsignaturaSeleccionado = 0;
    this.filtroSeccionSeleccionado = 0;
    this.filtroDocenteSeleccionado = 0;
    this.filtroAsignaturas = [];
    this.filtroSecciones = [];
    this.filtroDocentes = [];
    this.searchAsignaturaForm.setValue("")
    this.searchSeccionForm.setValue("")
    this.searchDocenteForm.setValue("")
  }

  limpiarFiltros(filtro: string): void {
    this.reporteEnProceso = false;
    switch(filtro) {
      case "anyo":
        this.filtroPeriodoSeleccionado = 0;
        this.filtroAsignaturaSeleccionado = 0;
        this.filtroPeriodos = [];
        this.filtroAsignaturas = [];
        this.filtroSecciones = [];
        this.filtroDocentes = [];
        this.searchAsignaturaForm.setValue("")
        this.searchSeccionForm.setValue("")
        this.searchDocenteForm.setValue("")
        break;
      case "periodo":
        this.casePeriodoSede()
        break;
      case "sede":
        this.casePeriodoSede()
        break;
      default:
        this.filtroAnyoSeleccionado = 0;
        this.filtroPeriodoSeleccionado = 0;
        this.filtroSedeSeleccionado = 0;
        this.filtroAsignaturaSeleccionado = 0;
        this.filtroTipoCambioSeleccionado = 'SECCIONES';
        this.filtroPeriodos = [];
        this.filtroAsignaturas = [];
        this.filtroSecciones = [];
        this.filtroDocentes = [];
        this.filtroTipoCalificacionSeleccionado = ''
        this.inputFecha = ''
        this.filtroOrigenSeleccionado = 0
        this.inputRutAlumno = ''
        this.searchAsignaturaForm.setValue("")
        this.searchSeccionForm.setValue("")
        this.searchDocenteForm.setValue("")
        this.submitted = false;
        this.tieneErrores["anyo"] = false;
        this.tieneErrores["periodo"] = false;
        this.tieneErrores["sede"] = false;
        this.tieneErrores["asignatura"] = false;
        this.tieneErrores["seccion"] = false;
        this.tieneErrores["docente"] = false;
        this.renderTabla = false;
        this.listaReportes = [];
        this.habilitarBtnGenerarReporte = this.activarBtnGenerar()
        break;
    }
  }

  getAnyos(): void {
    this._auditoria.getFiltrosAnhos().subscribe(
      (res: IListaAnhos) => {
        this.filtroAnyos = res.anyos
      }
    )
  }

  getPeriodos(): void {
    if(this.filtroAnyoSeleccionado != 0) {
      this._auditoria.getFiltrosPeriodos(this.filtroAnyoSeleccionado).subscribe(
        (res: IListaPeriodos) => {
          this.filtroPeriodos = res.periodos;
        }
      )
    }
  }
  getSedes(): void {
    let usuario = this._perfilamiento.getUsuario();
      this._auditoria.getFiltrosSedes(usuario.usuarioId).subscribe({
        next: (res: ISedes) => {
          this.filtroSedes = res.sedes;
        }
    })
  }
  getAsignaturas(): void {
    if (this.filtroAnyoSeleccionado != 0 && this.filtroPeriodoSeleccionado != 0) {
      this._auditoria.getFiltrosAsignaturas(this.filtroAnyoSeleccionado,this.filtroPeriodoSeleccionado,this.filtroSedeSeleccionado).subscribe({
        next: (res: IListaAsignaturas) => {
          this.filtroAsignaturas = res.asignaturas;
        }
      })
    }
  }

  getOrigenes(): void {
    this._auditoria.getOrigenes().subscribe(
      (res: IResOrigen) => {
        this.filtroOrigenes = res
      }
    )
  }

  displayFn(objeto: any): string {
    if(objeto.codigo) {
      return objeto?.codigo ? objeto.codigo.replace(/\w\S*/g, (w: string) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '';
    } else {
      return objeto && String(objeto.id) ? String(objeto.id).replace(/\w\S*/g, (w: string) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '';
    }
  }
  private _filter(value: string, filtro: string) {
    if (typeof value != 'string') {
      return [];
    }
    const filterValue = this._normalizeValue(value);
    if (filtro == "asignatura") {
      return this.filtroAsignaturas.filter((asignatura: { id: number, codigo: string }) => this._normalizeValue(asignatura?.codigo)?.includes(filterValue));
    } else if (filtro == "seccion") {
      return this.filtroSecciones.filter((seccion: {id: number, descSeccion: string}) => this._normalizeValue(String(seccion?.id))?.includes(filterValue));
    } else if (filtro == "docente") {
      return this.filtroDocentes.filter((docente: {docenteId: number, codigo: string}) => this._normalizeValue(docente?.codigo)?.includes(filterValue));
    }
    return []
  }
  private _normalizeValue(value: string): string {
    return value?.toLowerCase()?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, '');
  }
  resetearValidacion() {
    this.submitted = false;
    this.tieneErrores["anyo"] = false;
    this.tieneErrores["periodo"] = false;
    this.tieneErrores["sede"] = false;
    this.tieneErrores["asignatura"] = false;
    this.tieneErrores["seccion"] = false;
    this.tieneErrores["docente"] = false;
  }

  obtenerId(objeto: any): number {
    if(objeto.id){
      return objeto.id;
    }else{
      return objeto.docenteId
    }
  }
  obtenerCodigo(objeto: any): string {
      return objeto.codigo;
  }

  getListaDocentes(): void {
    if (this.filtroAnyoSeleccionado != 0 && this.filtroPeriodoSeleccionado != 0) {
      let body = {
        anyo: this.filtroAnyoSeleccionado,
        periodoId: this.filtroPeriodoSeleccionado,
        sedeId: this.filtroSedeSeleccionado,
        asignaturaId: this.filtroAsignaturaSeleccionado,
        seccionId: this.filtroSeccionSeleccionado
      }
      this._auditoria.getFiltrosIdDocente(body).subscribe({
        next: (res: IDocentesID) => {
          this.filtroDocentes = res.docentes;
        }
      })
    }
  }
  getListaSecciones(): void {
    let body = {
      anyo: this.filtroAnyoSeleccionado,
      periodoId: this.filtroPeriodoSeleccionado,
      sedeId: this.filtroSedeSeleccionado
    }
    this._auditoria.getFiltrosSeccion(body).subscribe({
      next: (res: ISecciones) => {
        this.filtroSecciones = res.secciones;
        this.filtroSecciones.sort(function(a,b){return a.id - b.id;});
      }
    })
  }

  fnNoTieneErrores(noTieneErrores: boolean = false): boolean {
    if ( this.filtroAnyoSeleccionado == 0) {
      this.tieneErrores["anyo"] = true;
    }
    if ( this.filtroPeriodoSeleccionado == 0) {
      this.tieneErrores["periodo"] = true;
    }
    if ( this.filtroSedeSeleccionado == 0 && this.rolUsuario === 2 ) {
      this.tieneErrores["sede"] = true;
    }
    if (this.filtroAnyoSeleccionado != 0 && this.filtroPeriodoSeleccionado != 0) {
      noTieneErrores = true
      if ( this.rolUsuario === 2 && this.filtroSedeSeleccionado == 0 ) {
        noTieneErrores = false
      }
    }
    return noTieneErrores
  }

  fnErroresAutocompletado(noTieneErrores: boolean = false, errorEnAutoCompletado: boolean = false): any {
    noTieneErrores = this.fnNoTieneErrores(noTieneErrores)
    if (typeof this.searchAsignaturaForm.value !== 'object' && this.searchAsignaturaForm.value != "") {
      noTieneErrores = false;
      errorEnAutoCompletado = true;
      this.tieneErrores["asignatura"] = true;
    }
    if (typeof this.searchSeccionForm.value !== 'object' && this.searchSeccionForm.value != "") {
      noTieneErrores = false;
      errorEnAutoCompletado = true;
      this.tieneErrores["seccion"] = true;
    }
    if (typeof this.searchDocenteForm.value !== 'object' && this.searchDocenteForm.value != "") {
      noTieneErrores = false;
      errorEnAutoCompletado = true;
      this.tieneErrores["docente"] = true;
    }
    if (errorEnAutoCompletado) {
      this.error = "Debe seleccionar un ítem de la lista";
      this.limpiarError();
    }
    return {
      noTieneErrores,
      errorEnAutoCompletado
    }
  }

  fnBody(): any {
    return {
      anyo: this.filtroAnyoSeleccionado,
      periodoId: this.filtroPeriodoSeleccionado,
      tipoCambio: this.filtroTipoCambioSeleccionado,
      sedeId: this.filtroSedeSeleccionado != 0 ? this.filtroSedeSeleccionado : null,
      asignaturaId: this.filtroAsignaturaSeleccionado != 0 ? this.filtroAsignaturaSeleccionado : null,
      codigoAsignatura: this.filtroCodigoAsignaturaSeleccionado != '' ? this.filtroCodigoAsignaturaSeleccionado : null,
      seccionId: this.filtroSeccionSeleccionado != 0 ? this.filtroSeccionSeleccionado : null,
      docenteId: this.filtroDocenteSeleccionado != 0 ? this.filtroDocenteSeleccionado : null,
      tipoCalificacion: this.filtroTipoCalificacionSeleccionado,
      fecha: this.inputFecha !== '' ? `${this.inputFecha.split('-')[2]}/${this.inputFecha.split('-')[1]}/${this.inputFecha.split('-')[0]} 00:00:00` : '',
      idOrigen: this.filtroOrigenSeleccionado,
      rut: this.inputRutAlumno
    }
  }

  busqueda(): void {
    this.submitted = true
    let { noTieneErrores } = this.fnErroresAutocompletado()
    
    if (noTieneErrores) {
      let body = this.fnBody()
      this.renderTabla = false;
      this._auditoria.getListadoReportes(body).subscribe({
        next: (res: IListaReportes) => {
          this.reporteEnProceso = false;
          if (res.error == null) {
            this.listaReportes = res.solicitudes;
            this.listaReportes.forEach(reporte => {
              if (reporte.estadoProceso == "EP") {
                this.reporteEnProceso = true;
              }
            })
            this.renderTabla = true;
          }
        }
      })
    }
  }
  actualizarTabla(): void {
    this.funcionIntervalo = setInterval(() =>{
      if (this.reporteEnProceso) {
        this.busqueda();
      }

    }, 35000);
  }
  ngOnDestroy(): void {
    clearInterval(this.funcionIntervalo);

  }
  generarSolicitudReporte(): void {
    this.submitted = true;
    let { noTieneErrores } = this.fnErroresAutocompletado()

    if (noTieneErrores) {
      let body = this.fnBody()
      this._auditoria.generarSolicitudReporte(body).subscribe({
        next: (res: IListaReportes) => {
          this.reporteEnProceso = false;
          if (res.error != null) {
            this.error = res.error.mensaje;
            this.limpiarError();
          } else {
            this.busqueda();
          }
        }
      })
    }
  }
  obtenerReporte(idSolicitud: number, fecha: string): void {
    this._auditoria.getReporte(idSolicitud).subscribe(
        async (res: any) => {
        const contentDispositionHeader = res?.headers?.get('Content-Disposition')
        const fileName = contentDispositionHeader?.split(';')[1]?.trim()?.split('=')[1]
        const bufferPromise = await res?.body.arrayBuffer();
        const csvData = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), bufferPromise], {type: "text/plain;charset=utf-8"});
        saveAs(csvData, fileName?.replace(/"/g, '') ?? 'reporteAuditoria.csv')
      }
    )
  }

  saveAsXlsxFile ( base64: string, nombreArchivo: string ) {
    const mediaType="data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"
    const file = base64
    let a = document.createElement('a')
    a.href = mediaType+file
    a.download = nombreArchivo+'.xlsx'
    a.click()
  }

  limpiarError(): void {
    setTimeout(() => {
      this.error = "";
    }, 10000);
  }

}
